import moment from 'moment'

/**
 *  Formatting data - Calculated items count by mobileOs
 * @param {object} data
 * @return {object} amount and group items by mobileOs in percent
 */
export const formatScansOs = ({ data }) =>
  data.reduce(
    (acc, item, index, arr) => {
      acc.items[item.mobileOs] =
        (acc.items[item.mobileOs] || 0) + 100 / arr.length

      if (arr.length - 1 === index) {
        const keys = Object.keys(acc.items)
        keys.forEach(key => {
          acc.items[key] = Math.round(acc.items[key])
        })
      }
      acc.amount += 1
      return acc
    },
    { amount: 0, items: {} },
  )

/**
 *  Formatting data - Calculated items count by city
 * @param {object} data
 * @return {object} amount and group items by city
 */
export const formatScansCity = ({ data }) =>
  data.reduce(
    (acc, item) => {
      acc.items[item.city] = (acc.items[item.city] || 0) + 1
      acc.amount += 1
      return acc
    },
    { amount: 0, items: {} },
  )

export const getFormattedValue = ({ headerName, row, campaignName }) => {
  switch (headerName) {
    case 'createdAt':
      return moment(+row[headerName]).format('DD/MM/YYYY HH:mm')
    case 'id':
      return `${campaignName} - ${row[headerName]}`
    default:
      return row[headerName]
  }
}



// WEBPACK FOOTER //
// ./src/Containers/StatsOverview/components/CampaignPerforming/utils.js